export const userLogin = "USERLOGIN";
export const resumeList = "RESUMELIST";
export const resumeData = "RESUMEDATA";
export const chatListData = "CHATLISTDATA";
export const socket = "SOCKET";
export const allChatMeesage = "ALLCHATMESSAGE";
export const activeChatPopup = "ACTIVECHATPOPUP";
